var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandAccordionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 4.47727 15.5227 0 10 0C4.47727 0 0 4.47727 0 10C0 15.5227 4.47727 20 10 20C15.5227 20 20 15.5227 20 10ZM1.66668 10C1.66668 5.39773 5.39773 1.66668 10 1.66668C14.6023 1.66668 18.3333 5.39773 18.3333 10C18.3333 14.6023 14.6023 18.3333 10 18.3333C5.39773 18.3333 1.66668 14.6023 1.66668 10Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7559 8.92259C15.0814 8.59716 15.0814 8.0695 14.7559 7.74407C14.4305 7.41864 13.9028 7.41864 13.5774 7.74407L9.99999 11.3215L6.42257 7.74407C6.09714 7.41864 5.56948 7.41864 5.24405 7.74407C4.91862 8.0695 4.91862 8.59716 5.24405 8.92259L9.41073 13.0893C9.73616 13.4147 10.2638 13.4147 10.5892 13.0893L14.7559 8.92259Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandAccordionIcon);
export default __webpack_public_path__ + "static/media/ExpandAccordionIcon.36edd616d94b996ce5793e2a21a3e45e.svg";
export { ForwardRef as ReactComponent };